/**
 * Lista de FALLBACK das bases exibidas no combo da apex central.
 *
 * A fonte primária é o endpoint público GET /api/tenants/active
 * (ver @/services/tenants/publicTenants). Esta lista só é usada quando o
 * endpoint falha (ex.: ainda gated por tenant -> 401 na central, ou rede off).
 *
 * Por ser fallback, NÃO traz `loginUrl`: o CentralBaseSelector monta a URL a
 * partir do `slug` de forma sensível ao ambiente (sufixo -homol em homol).
 * Mantenha só o essencial aqui; o resto vem do backend.
 */

export interface FallbackTenant {
  /** Subdomínio em produção (ex.: "saoroque" -> saoroque.escolarai.com.br). */
  slug: string;
  /** Nome completo. */
  name: string;
  /** Nome curto (opcional). */
  shortName?: string;
}

export const BASES: FallbackTenant[] = [
  { slug: "saoroque", name: "Prefeitura de São Roque", shortName: "São Roque" },
  { slug: "buenosaires", name: "Prefeitura de Buenos Aires", shortName: "Buenos Aires" },
  // Adicione bases conhecidas aqui como rede de segurança, se desejar.
];
